module.exports = __webpack_public_path__ + "static/img/gg2.e1c11fc0.jpg";